export type Severity13849 = 'S1' | 'S2'
export type Frequency13849 = 'F1' | 'F2'
export type Possibility13849 = 'P1' | 'P2'

export type PlrAssessment13849 = {
  severity: Severity13849
  frequency: Frequency13849
  possibilityOfAvoidance: Possibility13849
  determiningHazard: {
    id: string
    description: string | null
    type: string | null
  }
}

export type PlrProbabilityOfOccurrence = 'HIGH' | 'LOW'

/** Nullable per-dimension overrides; null = use inferred assessment for that dimension. */
export type PlrAssessmentOverride = {
  severity: Severity13849 | null
  frequency: Frequency13849 | null
  possibilityOfAvoidance: Possibility13849 | null
}

export function hasPlrAssessmentOverride(
  override: PlrAssessmentOverride | null | undefined
): boolean {
  if (override == null) {
    return false
  }

  return (
    override.severity != null ||
    override.frequency != null ||
    override.possibilityOfAvoidance != null
  )
}

/**
 * Frozen baselines at PLr confirmation. Effective fields = what the user accepted;
 * inferred fields = hazard-derived baseline at confirm time (optional on legacy rows).
 */
export type PlrConfirmedSnapshot = {
  plrGraph: string
  severity: Severity13849
  frequency: Frequency13849
  possibilityOfAvoidance: Possibility13849
  determiningHazardId: string
  inferredSeverity?: Severity13849
  inferredFrequency?: Frequency13849
  inferredPossibilityOfAvoidance?: Possibility13849
  inferredDeterminingHazardId?: string
}

export type SafetyFunctionPlrUndeterminedReason =
  | 'NO_LINKED_RRM'
  | 'NO_ELIGIBLE_RRM'
  | 'RRM_NOT_LINKED_TO_HAZARD'
  | 'HAZARD_MISSING_RISK_DIMENSIONS'

export type PlrReviewStatus = 'UNDETERMINED' | 'REQUIRES_REVIEW' | 'CONFIRMED'

/** Compute-on-read detail for Requires Review messaging (ENG-2053). */
export type PlrReviewReason =
  | 'NEVER_CONFIRMED'
  | 'EFFECTIVE_ASSESSMENT_CHANGED'
  | 'INFERRED_DRIFT_UNDER_OVERRIDE'
